import {
    type AnalyticsClientInterface,
    type AnalyticsDateRangeParam,
    type UsageType,
    axiosCacheInterceptorRequestConfig,
} from './analyticsClient.types';
import BaseClient, { type BaseClientConfig } from '../BaseClient';

export default class CorporateAnalyticsClient extends BaseClient implements AnalyticsClientInterface {
    constructor(private teamId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getMarketingSubscriptionsTotalByStatus() {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/current/contacts/total-by-subscription-status`;
        return this.makeCoreApiRequest(url, 'post', null, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptIns(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-opt-ins`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptOuts(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-opt-outs`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptOutsByEntryPoint(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-opt-outs-by-entry-point`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptInsByEntryPoint(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-opt-ins-by-entry-point`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getContactsTotalCreated(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-created`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getContactsTotalCreatedByEntryPoint(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/contacts/total-created-by-entry-point`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getContactsTotalActiveEntryPoints(params?: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/current/contacts/total-active-entry-points`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getUsageTotalByType(params: AnalyticsDateRangeParam & { filters: { usage_types: UsageType[] } }) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/time-series/usage/total-by-type`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }
}
